import { render } from "./Sobremi.vue?vue&type=template&id=28ce16b4&scoped=true"
import script from "./Sobremi.vue?vue&type=script&lang=js"
export * from "./Sobremi.vue?vue&type=script&lang=js"

import "./Sobremi.vue?vue&type=style&index=0&id=28ce16b4&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-28ce16b4"

export default script